<template>
	<div>
		<div class="message-list">
			<div class="message-list--items">
				<ListItem is-recipient>
					<template #text>
						<b>Die Kandidaten müssen bei skilldoo keinen Lebenslauf hinterlegen!</b>
					</template>
				</ListItem>
				<ListItem is-recipient>
					<template #text>
						Wenn du trotzdem einen anforderst, kann es sein, dass du den Kandidaten verlierst.<br/>
						Möchtest du das Risiko eingehen?
					</template>
				</ListItem>
			</div>
		</div>
		<div class="d-flex align-items-center mt-5">
			<div class="flex-grow-1 mr-2">
				<Button
					v-if="!loading"
					text="Abbrechen"
					icon="close"
					@click="$emit('cancel')"
				/>
			</div>
			<div>
				<Button
					text="Lebenslauf trotzdem anfordern"
					icon="checkmark"
					secondary
					:disabled="loading"
					:loading="loading"
					@click="$emit('request')"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import ListItem from "@/vue/communication/conversation/message/ListItem";
import Button from "@/vue/common/Button.vue";

export default {

	components: {
		Button,
		ListItem,
	},

	props: {
		loading: {
			type: Boolean,
			required: true
		}
	}
}
</script>